import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { IGetData, IDataReq } from '../models/certify.model';
import { IConfirmReq, IFindIdParams, IGenerateReq, IMemberCheckReq, IResetPasswordReq, IVerifyForPasswordReq } from '../models/auth.model';
import { 
  confirmCodeForId, 
  confirmCodeForPassword, 
  findMemberId, 
  findWebId, 
  generateCodeForId, 
  generateCodeForPassword, 
  resetPassword, 
  verifyForPassword 
} from '../api/join.api';

interface IFindState {
  data: string | null | [];
  isLoading: boolean;
  error?: AxiosError | string;
  isFinalStep: boolean;
}

const initialState: IFindState = {
  data: null,
  isLoading: false,
  isFinalStep: false,
};

const findSlicer = createSlice({
  name: 'find',
  initialState,
  reducers: {
    requestStart: (state: IFindState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IFindState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    requestSuccess: (state: IFindState, action: PayloadAction<IGetData>) => {
      state.data = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    isFinalStep: (state, action) => {
      state.isFinalStep = action.payload;
    }
  },
});

export const { requestStart, requestFailure, requestSuccess, isFinalStep } =
  findSlicer.actions;

export default findSlicer.reducer;

export const doGenerateCodeForId =
  (data: IDataReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await generateCodeForId(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doConfirmCodeForId =
  (data: IConfirmReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await confirmCodeForId(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doFindIdList =
  (data: IFindIdParams): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await findMemberId(data);
      dispatch(isFinalStep(true));
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      dispatch(isFinalStep(false));
      return e.response;
    }
  };

export const doFindWebId =
  (data: IMemberCheckReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await findWebId(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };  

export const doGenerateCodeForPassword =
  (data: IGenerateReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await generateCodeForPassword(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doConfirmCodeForPassword =
  (data: IConfirmReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await confirmCodeForPassword(data);
      dispatch(isFinalStep(true));
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doUpdatePassword =
  (data: IVerifyForPasswordReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await verifyForPassword(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doResetPassword =
  (data: IResetPasswordReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await resetPassword(data);
      dispatch(requestSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };
